"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Logger = /** @class */ (function () {
    function Logger(moduleName) {
        this.moduleName = moduleName;
    }
    Logger.prototype.error = function (msg) {
        console.error("[" + this.moduleName + "] " + msg);
    };
    Logger.prototype.warn = function (msg) {
        console.warn("[" + this.moduleName + "] " + msg);
    };
    Logger.prototype.info = function (msg) {
        // tslint:disable-next-line
        console.log("[" + this.moduleName + "] " + msg);
    };
    Logger.prototype.verbose = function (msg) {
        // tslint:disable-next-line
        console.log("[" + this.moduleName + "][v] " + msg);
    };
    return Logger;
}());
exports.Logger = Logger;
function getLogger(moduleName) {
    return new Logger(moduleName);
}
exports.getLogger = getLogger;
//# sourceMappingURL=log.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/bvd3/dist/log.js
// module id = 93
// module chunks = 0 1